import { GameVariant } from '@draughts/shared';

/**
 * A self-contained puzzle that is validated ENTIRELY in the browser (via
 * @draughts/core), with no backend round-trip and no authentication. The whole
 * server puzzle flow (start/move/hint/give-up) is auth-gated, so the landing
 * "Risolvi" demo — which every visitor, logged-in or not, must be able to
 * solve — carries its own solution + forced-win tree instead.
 */
export interface LocalPuzzle {
  fen: string;
  variant: GameVariant;
  playerColor: 'white' | 'black';
  /** Number of the solver's (player's) key moves. */
  moveCount: number;
  /** Canonical alternating line [playerMove, opponentReply, playerMove, …]. */
  solution: Array<{ from: number; to: number }>;
  /**
   * Normalised position key (boardStateToFen) → all winning player moves there.
   * Authoritative for accepting a move, exactly like the server validator.
   */
  solutionTree: Record<string, Array<{ from: number; to: number }>>;
}

/**
 * The fixed landing demo — International 10×10, White to play and win. Solved and
 * verified offline with the same engine the runtime uses (strict forced win, no
 * eval-win fallback). This constant is the SINGLE source of truth for the demo:
 * the landing preview board (components/home/LandingPuzzle.tsx) reads its FEN
 * from here, and the in-browser validator accepts moves from `solutionTree`.
 */
export const DEMO_INT_PUZZLE: LocalPuzzle = {
  fen: 'W:W18,40,44,50:B5,7,9,28,30',
  variant: GameVariant.INTERNATIONAL,
  playerColor: 'white',
  moveCount: 4,
  solution: [
    { from: 18, to: 12 },
    { from: 7, to: 18 },
    { from: 40, to: 34 },
    { from: 30, to: 39 },
    { from: 44, to: 4 },
    { from: 5, to: 10 },
    { from: 4, to: 15 },
  ],
  solutionTree: {
    'W:W18,40,44,50:B5,7,9,28,30': [{ from: 18, to: 12 }],
    'W:W40,44,50:B5,9,18,28,30': [{ from: 40, to: 34 }],
    'W:W44,50:B5,9,18,28,39': [{ from: 44, to: 4 }],
    'W:WK4,50:B10': [{ from: 4, to: 15 }],
  },
};
